import { MA_APP_IDS } from '@wix/members-area-app-definitions';
import { getErrorData } from '@wix/members-area-commons-ts';
import type { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { RELOAD_ICON_SVG } from '../../../constants';
import type {
  ErrorHandler,
  ErrorStateService as IErrorStateService,
  TFunction,
  W,
} from '../../../types';
import type { MembersAreaPublicAPI } from '../../../types/services';

export class ErrorStateService implements IErrorStateService {
  t: TFunction;
  errorHandler: ErrorHandler;
  refreshPage: () => void;

  constructor(
    private readonly $w: W,
    private readonly membersAreaPublicAPI: MembersAreaPublicAPI,
    flowAPI: PlatformControllerFlowAPI,
  ) {
    this.t = flowAPI.translations.t;
    this.errorHandler = flowAPI.errorHandler;

    this.refreshPage = () => {
      const { wixCodeApi } = flowAPI.controllerConfig;
      const url = wixCodeApi.location.url;
      wixCodeApi.location.to?.(url);
    };
  }

  setToPageLoadErrorContent(error: unknown) {
    const { message } = getErrorData(error, this.errorHandler.getResolvedError);

    this.$w('#text1').text = this.t('app.error-state.page-load.title');
    this.$w('#text2').text = message;

    this.resetHomeButton();
    this.$w('#homeButton').label = this.t('app.error-state.page-load.button');
    this.$w('#homeButton').icon = RELOAD_ICON_SVG;
    this.$w('#homeButton').onClick(this.refreshPage);
  }

  resetToNotFoundContent() {
    this.$w('#text1').text = this.t('app.empty-state.not-found.title');
    this.$w('#text2').text = this.t('app.empty-state.not-found.description');

    this.resetHomeButton();
    this.$w('#homeButton').label = this.t('app.empty-state.not-found.button');
    this.$w('#homeButton').link = '/';
  }

  async setUserIsBlockedContent(memberName: string) {
    const openBlockedMembersModalQuery = '?blockedMembersModal=true';
    const myAccountPath = await this.membersAreaPublicAPI.getSectionUrl({
      appDefinitionId: MA_APP_IDS.MY_ACCOUNT.appDefinitionId,
      sectionId: MA_APP_IDS.MY_ACCOUNT.pageId,
      widgetId: MA_APP_IDS.MY_ACCOUNT.widgetId,
    });

    this.$w('#text1').text = this.t('app.empty-state.user-is-blocked.title', {
      memberName,
    });
    this.$w('#text2').text = this.t(
      'app.empty-state.user-is-blocked.description',
    );

    this.resetHomeButton();
    this.$w('#homeButton').label = this.t(
      'app.empty-state.user-is-blocked.button',
    );
    this.$w('#homeButton').link = myAccountPath + openBlockedMembersModalQuery;
  }

  private resetHomeButton = () => {
    this.$w('#homeButton').icon = '';
    this.$w('#homeButton').link = '';
    // @ts-expect-error
    this.$w('#homeButton').removeEventHandler('onClick', this.refreshPage);
  };
}
